import { render, staticRenderFns } from "./TrainingPage.vue?vue&type=template&id=2072701a&scoped=true"
import script from "./TrainingPage.vue?vue&type=script&lang=js"
export * from "./TrainingPage.vue?vue&type=script&lang=js"
import style0 from "./TrainingPage.vue?vue&type=style&index=0&id=2072701a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072701a",
  null
  
)

export default component.exports